import React from "react";
import LeftText from "../sections/Protag/LeftText";
import RighText from "../sections/Protag/RightText";
import SuccessSlider from "../sections/Protag/SuccessSlider";
import PricingGuide from "../sections/Protag/PricingGuide";
import ImageZoomEffect from "../sections/Protag/ZoomContainer";
import FullLengthSlider from "../sections/AllServicesSlider/FullLengthSlider";
import {
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS,
  PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS,
} from "../sections/Public/shared/publicLayoutSpec";

// class ErrorBoundary extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = { hasError: false };
//   }

//   static getDerivedStateFromError(error) {
//     return { hasError: true };
//   }

//   componentDidCatch(error, errorInfo) {
//     console.error('Error in ProTags:', error, errorInfo);
//   }

//   render() {
//     if (this.state.hasError) {
//       return null; // Return null or a fallback UI
//     }

//     return this.props.children;
//   }
// }

const ProTags = () => {
  return (
    // <ErrorBoundary>
      <div className="relative">
        {/* <ImageZoomEffect /> */}
        <PricingGuide />
        <LeftText
          heading={"Stand out with the PRO plan"}
          text={
            "The PRO plan ensures your business always stands out with featured posts that stay at the top of search results, giving you unmatched visibility. Completing and verifying your profile builds trust and helps customers confidently choose you from the crowd."
          }
        />
        <RighText
          heading={"Build trust and engage customers directly"}
          text={
            "When businesses complete their profile with contactable details like mobile, email, and social media, customers can reach out directly to discuss their needs. The PRO plan ensures your business stays visible and accessible, helping you establish trust and build meaningful connections faster."
          }
        />
        <SuccessSlider />
        <FullLengthSlider
          className={PUBLIC_SECTION_GAP_CLASS}
          itemGapClassName={PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS}
          labelClassName={PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS}
        />
      </div>
    // </ErrorBoundary>
  );
};

export default ProTags;
